import {trace} from "mobx";

export default function getModelChanges(prev, current) {
    const detectChanges = (prev, current, changeList, ns) => {
        let changes = {}
        if (typeof current !== 'object') {
            if (prev != current)
                changeList.push(ns);
            return;
        }
        for (let [name, value] of Object.entries(current)) {
            let prevValue = prev[name];
            let changed = false;
            let fullName = ns === '' ? name : ns + '.' + name;
            if (value === null) {
                changed = prevValue !== null;
            } else if (Array.isArray(value)) {
                if (!prevValue || value.length !== prevValue.length) {
                    changed = true;
                } else {
                    let listChanges = [];
                    for (let i = 0; i < value.length && listChanges.length === 0; i++)
                        detectChanges(prevValue[i], value[i], listChanges, '')
                    if (listChanges.length > 0)
                        changed = true;
                }
            } else if (typeof value === 'object' && typeof prevValue === 'object') {
                if (prevValue !== null)
                    detectChanges(prevValue, value, changeList, fullName);
                else
                    changed = true;
            } else if (prevValue != value) {
                changed = true;
            }
            if (changed)
                changeList.push(fullName);
        }
    }
    let changeList = [];
    detectChanges(prev, current, changeList, '');
    return changeList;
}
